// extracted by mini-css-extract-plugin
export default {"header":"PartsTable_header__BJJA6","body":"PartsTable_body__VOQDz","error":"PartsTable_error__lP3Hv"};